import { FC, useState } from 'react';
import { ConfiguracaoRevendaForm } from 'src/components/configuracao/ConfiguracaoRevendaForm'
import { TabContent } from 'src/framework/components/navigations/tabs/TabContent';
import { TabControl } from 'src/framework/components/navigations/tabs/TabControl';

const Configuracao: FC = () => {
    const [tabContas, setTabContas] = useState("configurações");
    const handleChangeTab = (tab: string) => {
        setTabContas(tab);
    };
    return <>
        <TabControl
            currentTabName={tabContas}
            onChangeTab={handleChangeTab}
        >
            <TabContent name={"configurações"} label={"configurações"} visible={true}>
                <ConfiguracaoRevendaForm />
            </TabContent>
        </TabControl>
    </>
}

export { Configuracao }